<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <form [formGroup]="form" (ngSubmit)="form.valid && onSubmit()" class="edit-twoFA-form">
    <div class="edit-twoFA">
      <div class="edit-twoFA-heading">
        Edit two-factor authentication phone
      </div>
    </div>
    <hr class="twoFA-hr margin-bottom mb24" [ngClass]="{'hr-18': isAcmic}">
    <div class="edit-twoFA-detail-container">
      <div class="edit-twoFA-detail-subContainer w-100-percent">
        <div class="edit-twoFA-phone-container w-100-mobile">
          <div class="edit-twoFA-phone">
            Phone Number
          </div>
          <div class="phone-input-wrapper" [ngClass]="{'okta-error-div': !isAcmic && (phoneNumber?.dirty && 
                    !phoneNumber?.errors?.['required'] &&
                        !phoneNumber?.errors?.['pattern'] &&
                        phoneNumber?.value?.length > 0 &&
                        phoneNumber?.value?.length < 10) || errorMsg}">
            <span class="country-code" [ngClass]="{'okta-error-span': !isAcmic && (phoneNumber?.dirty && 
                    !phoneNumber?.errors?.['required'] &&
                        !phoneNumber?.errors?.['pattern'] &&
                        phoneNumber?.value?.length > 0 &&
                        phoneNumber?.value?.length < 10) || errorMsg}">{{ countryCode}}</span>
            <input #phoneInput type="tel" formControlName="phoneNumber" class="phone-number-input" maxlength="15"
              (input)="onPhoneInput($event)" [ngClass]="{'okta-error-input': !isAcmic && (phoneNumber?.dirty && 
                    !phoneNumber?.errors?.['required'] &&
                        !phoneNumber?.errors?.['pattern'] &&
                        phoneNumber?.value?.length > 0 &&
                        phoneNumber?.value?.length < 10) || errorMsg}" />
          </div>
          <div>
            <div *ngIf="phoneNumber?.dirty && 
                    !phoneNumber?.errors?.['required'] &&
                        !phoneNumber?.errors?.['pattern'] &&
                        phoneNumber?.value?.length > 0 &&
                        phoneNumber?.value?.length < 10" class="error mfa-error">

              <img src="./assets/img/images/mfa-icon-warning.png" />
              <div class="mfa-error-text">Enter a valid phone number</div>
            </div>
            <div *ngIf="errorMsg" class="mfa-error-text">
              {{errorMsg}}
            </div>
          </div>
        </div>
      </div>

      <div class="edit-twoFA-msg">
        Message and data rates may apply from your mobile carrier.
      </div>
    </div>
    <div class="edit-twoFA-btns margin-top mt24">
      <div class="w-100-mobile">
        <button type="button" class="edit-twoFA-cancel edit-twoFA-cancel-text" (click)="cancelEdit()">Cancel</button>
      </div>
      <div class="w-100-mobile">
        <mapfre-modal #modalRef [modalOptions]="confirmationModal" [disabledValue]="isModalDisabled"
          [hideModal]="hideModal" (click)="triggerPhoneModal()" (hideModalOutput)="resetHideModal()">
          <div class="okta-modal-body">
            <ng-container *ngIf="isAcmic else maError">
              <div class="okta-header-icon">
                <img alt="warningicon" src="./assets/img/images/okta-modal-icon-warning-acmic.png" />
              </div>
            </ng-container>
            <ng-template #maError>
              <div class="okta-header-icon">
                <img alt="warningicon" src="./assets/img/images/okta-modal-icon-warning.png" />
              </div>
            </ng-template>

            <div class="okta-modal-inner-content">
              <div class="okta-modal-title">Confirm phone update</div>
              <div class="okta-sub-title">Are you sure you want to update?</div>

              <div class="phone-detail-section">
                <div class="phone-detail-sub-section">
                  <div class="label">Current phone: </div>
                  <div class="current-phone-value">{{ countryCode }} {{ formattedCurrentPhone }}</div>
                </div>

                <div class="phone-detail-sub-section">
                  <div class="label new-phone-space">New phone: </div>
                  <div class="current-phone-value">{{ countryCode }} {{ formattedNewPhone }}</div>
                </div>
              </div>
              <div class="phone-confirmation-text">
                Once you confirm this update, your previous phone number will no longer be valid
                for two-factor authentication during sign in.
              </div>
            </div>
            <hr class="okta-hr" *ngIf="!isAcmic">

            <div class="okta-modal-btn-container">
              <div class="okta-confirm-btn">
                <mapfre-button (click)="changePhone()" [ngClass]="{ 'edit-mfaPhone-modal custom_loader': loader }"
                  additionalClasses="basic primary large-btn okta-confirm">
                  Confirm new phone
                </mapfre-button>
              </div>

              <div class="okta-cancel-btn">
                <mapfre-button (click)="hideModalAction()" additionalClasses="ghost secondary large-btn okta-cancel">
                  Cancel
                </mapfre-button>
              </div>
            </div>

          </div>
        </mapfre-modal>
      </div>
    </div>
  </form>
</ng-container>